<template>
    <div class="admin-page">
        <!-- Main content -->
        <div class="main-cnt">
            <div class="content-white">

                <div class="content-body">
                    <div class="box-content">
                        <div class="row h-100">
                            <div class="col-12 h-100">

                                <div class="block-cnt">

                                    <div class="loading" v-if="(loading == true)" data-vv-scope='s3'></div>

                                    <div class="table-list" v-if="(listCompany != null) && (loading == false)" data-vv-scope='s4'>
                                        <table class="table">
                                            <tr>
                                                <th class="no-checkbox">{{ $t('company.general.code') }}</th>
                                                <th>{{ $t('company.general.full_name') }}</th>
                                                <th>{{ $t('company.general.cabinet_id') }}</th>
                                            </tr>

                                            <tr v-for="company in listCompany" :key="company.id">
                                                <td class="no-checkbox">{{ company.code }}</td>
                                                <td>{{ company.name }}</td>
                                                <td>{{ company.cabinet_id }}</td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="no-data" v-if="(listCompany == null) && (loading == false)" data-vv-scope='s6'>
                                        {{ $t('general.no_data') }}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompanyManagementService from '@/services/admin/company.service';
import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';
import Utils from '@/helpers/utils';

export default {
    components: {},
    name: 'ListCompanyManagement',
    data () {
        return {
            loading: false,
            lists: null,
        };
    },
    created () {
        this.fetchData();
    },
    computed: {
        listCompany: function() {
            this.$forceUpdate();
            if (this.lists && this.lists.length > 0) {
                const _list = [];
                this.lists.forEach((company) => {
                    const cabinet_id = [company.cabinet_id_signed, company.cabinet_id_unsigned];
                    _list.push({
                        id: company.id,
                        name: !Utils.isEmptyStr(company.name) ? company.name : "-",
                        code: !Utils.isEmptyStr(company.code) ? company.code : "-",
                        cabinet_id: !Utils.isEmptyArr(cabinet_id) ? cabinet_id.join(', ') : "-",
                    });
                });
                return _list;
            }
            return null;
        },
    },
    watch: {
        '$route' () {
            this.fetchData();
        },
    },
    methods: {
        fetchData () {
            this.$forceUpdate();
            this.loading = true;

            CompanyManagementService.listCompany()
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    this.lists = (response.status == 200 && response.data.length > 0) ? response.data : null;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                    console.error(error);
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/CompanyManagement/List.vue